import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link
              to="/"
              className="text-lg font-semibold text-foreground-900 tracking-tight cursor-pointer"
            >
              Sugargoo Spreadsheet
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              The ultimate database for Sugargoo finds, reviews, and shopping guides. Your independent resource for smarter purchasing decisions.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              SEO Guides
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/sugargoo-spreadsheet-ultimate-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  Ultimate Guide
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-review" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  Sugargoo Review
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-shipping-cost" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  Shipping Cost Guide
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-coupon" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  Coupon &amp; Discount
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-buying-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  Shopping Guide
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              Popular Categories
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  Shoes
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  T-Shirts
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  Hoodies / Sweaters
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  Jackets
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              Resources
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Home</Link>
              </li>
              <li>
                <Link to="/sugargoo-warehouse" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Warehouse Guide</Link>
              </li>
              <li>
                <Link to="/is-sugargoo-legit" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Is Sugargoo Legit?</Link>
              </li>
              <li>
                <Link to="/sugargoo-best-finds" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Best Finds</Link>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Shop Now</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Sugargoo Spreadsheet. All rights reserved. This is an independent informational resource.
          </p>
          <p className="text-xs text-foreground-500">
            Visit our main site:{" "}
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-primary-500 hover:text-primary-600 transition-colors font-medium cursor-pointer"
            >
              kaspreadsheet.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}